export default __webpack_public_path__ + "static/hero-background-2-a010f7b21c860c7d2f24bdad07796b11.jpg";